import { activityLogService } from '../../services/activityLog.service'

const state = {
  logs: [],
  total: 0,
  loading: false,
  error: null,
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_LOGS(state, { logs, total }) {
    state.logs  = logs
    state.total = total
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_LOGS(state) {
    state.logs  = []
    state.total = 0
  }
}

const actions = {
  /** Fetch all logs with optional { limit, offset } */
  async fetchLogs({ commit }, params = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const data = await activityLogService.getAll(params)
      commit('SET_LOGS', { logs: data.logs || [], total: data.total || 0 })
    } catch (err) {
      commit('SET_ERROR', err)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  /** Filter logs with { userId, action, dateFrom, dateTo, limit, offset } */
  async filterLogs({ commit }, params = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const data = await activityLogService.filter(params)
      commit('SET_LOGS', { logs: data.logs || [], total: data.total || 0 })
    } catch (err) {
      commit('SET_ERROR', err)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  /** Manually trigger 30-day purge */
  async purgeLogs({ dispatch }) {
    try {
      await activityLogService.purge()
      // Refresh after purge
      await dispatch('fetchLogs')
    } catch (err) {
      console.error('Failed to purge logs', err)
    }
  }
}

export const activityLogs = {
  namespaced: true,
  state,
  mutations,
  actions,
}
